interface charonOrBFFError {
  error?: string | any;
  errors?: string;
  message?: string;
}

export function isCryptoError(error: unknown) {
  return typeof error === 'string' && !error.includes('{');
}

export function isCharonOrBFFError(error: charonOrBFFError): string {
  if (error.error && typeof error.error !== "string") {
    return error.message!;
  }
  return error.error || error.errors!;
}


